import objectAssign from 'object-assign';
import _ from 'lodash';
import clone from 'clone';

import initialState from './initialState';
import * as types from '../constants/actionTypes';

export default function settingsPageReducer(state = initialState.settingsPageReducer, action) {
  let teams = [];
  let pickUpPoints = [];

  switch (action.type) {
    case types.DRIVER_DELETED: {
      drivers = clone(state.drivers);
      let driverToDelete = _.find(drivers, { id: action.driverToDelete });
      _.pull(drivers, driverToDelete);

      return objectAssign({}, state, { drivers: drivers, loaded: true});
    }      

    case types.USER_TEAMS_FETCHED:
      return objectAssign({}, state, { userTeams: action.teams });

    case types.OPERATOR_DELETED: {
      operators = clone(state.operators);
      let operatorToDelete = _.find(operators, { id: action.operatorToDelete });
      _.pull(operators, operatorToDelete);

      return objectAssign({}, state, { operators: operators, loaded: true});
    }      

    case types.DISPATCHER_DELETED: {
      dispatchers = clone(state.dispatchers);
      let dispatcherToDelete = _.find(dispatchers, { id: action.dispatcherToDelete });
      _.pull(dispatchers, dispatcherToDelete);

      return objectAssign({}, state, { dispatchers: dispatchers, loaded: true});
    }     

    case types.PLATFORM_DELETED: {
      dispatcherPlatforms = clone(state.dispatcherPlatforms);
      let platformToDelete = _.find(dispatcherPlatforms, { id: action.platformToDelete });
      _.pull(dispatcherPlatforms, platformToDelete);

      return objectAssign({}, state, { dispatcherPlatforms: dispatcherPlatforms, loaded: true});
    }      

    case types.OPERATOR_CREATED:
      return objectAssign({}, state, { operators: state.operators.concat([action.operator]), loaded: true });

    case types.PLATFORM_CREATED:
      return objectAssign({}, state, { dispatcherPlatforms: state.dispatcherPlatforms.concat([action.platform]), loaded: true });

    case types.DISPATCHER_CREATED:
      return objectAssign({}, state, { dispatchers: state.dispatchers.concat([action.dispatcher]),
          createdDispatcher: action.dispatcher, loaded: true });

    case types.DRIVER_CREATED:
      return objectAssign({}, state, { drivers: state.drivers.concat([action.driver])});

    case types.PICKPOINT_CREATED:
      return objectAssign({}, state, { pickUpPoints: state.pickUpPoints.concat([action.point]), loaded: true });

    case types.OPERATOR_UPDATED:
      operators = objectAssign([], state.operators);
      objectAssign(operators.find((operator) => operator.id === action.operator.id), action.operator);
      return objectAssign({}, state, { operators: operators, loaded: true });

    case types.PLATFORM_UPDATED:
      dispatcherPlatforms = objectAssign([], state.dispatcherPlatforms);
      objectAssign(dispatcherPlatforms.find((platform) => platform.id === action.platform.id), action.platform);
      return objectAssign({}, state, { dispatcherPlatforms: dispatcherPlatforms, loaded: true });

    case types.DRIVER_UPDATED:
      drivers = objectAssign([], state.drivers);
      objectAssign(drivers.find((driver) => driver.id === action.driver.id), action.driver);
      return objectAssign({}, state, { drivers: drivers, loaded: true });

    case types.DISPATCHER_UPDATED:
      dispatchers = objectAssign([], state.dispatchers);
      objectAssign(dispatchers.find((dispatcher) => dispatcher.id === action.dispatcher.id), action.dispatcher);
      return objectAssign({}, state, { dispatchers: dispatchers, loaded: true });

    case types.DISPATCHER_FOR_SETTINGS_FETCHED: {
      let updatedDispatchers = objectAssign([], state.dispatchers);
      objectAssign(updatedDispatchers.find((dispatcher) => dispatcher.id === action.dispatcher.id), action.dispatcher);
      return objectAssign({}, state, {dispatchers: updatedDispatchers});
    }      

    case types.CITYES_FETCHED: {
      let cities = action.cities.sort(function(a,b) {
        if ( a.name.en < b.name.en )
            return -1;
        if ( a.name.en > b.name.en )
            return 1;
        return 0;
      });
      return objectAssign({}, state, { cities: cities });
    }      

    case types.STATS_CLEARED:
        return objectAssign({}, state, { statistic: {}, loaded: true });
    case types.PLATFORM_FOR_SETTINGS_FETCHED:
      dispatcherPlatforms = objectAssign([], state.dispatcherPlatforms);
      objectAssign(dispatcherPlatforms.find((platform) => platform.id === action.platform.id), action.platform);
      return objectAssign({}, state, {dispatcherPlatforms: dispatcherPlatforms});

    case types.DISPATCHERS_FOR_FLEET_FETCHED:
      action.dispatchers.map((dispatcher) => dispatcher.role = 'dispatcher');
      return objectAssign({}, state, { dispatchers: action.dispatchers, loaded: true });

    case types.STATISTICS_FETCHED: {
      let stat = action.data.statistics ? action.data.statistics : action.data;
      return objectAssign({}, state, { statistic: stat, loaded: true });
    }
    
    case types.STATISTICS_FETCHED_FAILED: {      
      return objectAssign({}, state, { statistic: {}, loaded: true, error: action.error });
    }

    case types.OPERATOR_FOR_SETTINGS_FETCHED: {
      let updatedOperators = objectAssign([], state.operators);
      objectAssign(updatedOperators.find((operator) => operator.id === action.operator.id), action.operator);
      return objectAssign({}, state, {operators: updatedOperators});
    }      

    case types.DRIVER_FOR_SETTINGS_FETCHED:
      drivers = objectAssign([], state.drivers);
      objectAssign(drivers.find((driver) => driver.id === action.driver.id), action.driver);
      return objectAssign({}, state, {drivers: drivers});

    case types.OPERATORS_FOR_FLEET_FETCHED:
      return objectAssign({}, state, { operators: action.operators, loaded: true });

    case types.DRIVERS_FOR_FLEET_FETCHED:
      action.drivers.map((driver) => driver.role = 'driver');
      return objectAssign({}, state, { drivers: action.drivers, loaded: true });

    case types.PLATFORMS_FOR_FLEET_FETCHED:
      return objectAssign({}, state, { dispatcherPlatforms: action.dispatcherPlatforms, loaded: true });

    case types.USER_ADDED_TO_TEAM:
      return objectAssign({}, state, { addedToTeam: Date.now() });

    case types.USER_REMOVED_FROM_TEAM:
      return objectAssign({}, state, { removedFromTeam: Date.now() });

    case types.POINTS_FOR_SETTINGS_FETCHED:
      return objectAssign({}, state, {pickUpPoints: action.points});

    case types.PICKUPPOINT_EDITED:
      pickUpPoints = objectAssign([], state.pickUpPoints);
      objectAssign(pickUpPoints.find((point) => point.id === action.removedPickUpPoint.id), action.removedPickUpPoint);
      return objectAssign({}, state, { pickUpPoints: pickUpPoints });

    case types.TEAM_UPDATED: {
      let newTeams = objectAssign([], state.teams);
      objectAssign(newTeams.find((team) => team.id === action.team.id), action.team);
      return objectAssign({}, state, { teams: newTeams, loaded: true });
    }      

    case types.TEAM_CREATED:
    if (_.some(state.teams, { id: action.team.id })) {
      return state;
    }

    return objectAssign({}, state, { teams: state.teams.concat([action.team]), loaded: true });

    case types.TEAM_DELETED: {
      teams = clone(state.teams);
      let teamToDelete = _.find(teams, { id: action.teamToDelete });
      _.pull(teams, teamToDelete);

      return objectAssign({}, state, { teams: teams, loaded: true });
    }      

    case types.ALL_OPERATOR_USERS_FOR_SETTINGS_FETCHED:
      teams = action.teams;
      drivers = [];
      dispatchers = [];
      operators = [];
      dispatcherPlatforms = [];

      _.map(teams, (team) => {
        if(team.drivers) {
          _.map(team.drivers, (driver) => {
            driver.role = 'driver';
            drivers.push(driver);
          });
        }

        if(team.operators) {
          _.map(team.operators, (operator) => {
            operator.role = 'operator';
            operators.push(operator);
          });
        }

        if(team.dispatchers) {
          _.map(team.dispatchers, (dispatcher) => {
            dispatcher.role = 'dispatcher';
            dispatchers.push(dispatcher);
          });
        }

        if(team.dispatcherPlatforms) {
          _.map(team.dispatcherPlatforms, (dispatcherPlatform) => {
            dispatcherPlatform.role = 'dispatcherPlatform';
            dispatcherPlatforms.push(dispatcherPlatform);
          });
        }
      });
      return objectAssign({}, state, {allDrivers: drivers, allOperators: operators,
        allDispatchers: dispatchers, allDispatcherPlatforms: dispatcherPlatforms});

    case types.TEAM_FETCHED:
      let team = action.team;
      let drivers = [];
      let dispatchers = [];
      let operators = [];
      let dispatcherPlatforms = [];

      if(team.drivers) {
        _.map(team.drivers, (driver) => {
          driver.teamId = team.id;
          driver.role = 'driver';
          drivers.push(driver);
        });
        delete team.drivers;
      }

      if(team.operators) {
        _.map(team.operators, (operator) => {
          operator.teamId = team.id;
          operator.role = 'operator';
          operators.push(operator);
        });
        delete team.operators;
      }

      if(team.dispatchers) {
        _.map(team.dispatchers, (dispatcher) => {
          dispatcher.teamId = team.id;
          dispatcher.role = 'dispatcher';
          dispatchers.push(dispatcher);
        });
        delete team.dispatchers;
      }

      if(team.dispatcherPlatforms) {
        _.map(team.dispatcherPlatforms, (dispatcherPlatform) => {
          dispatcherPlatform.teamId = team.id;
          dispatcherPlatform.role = 'dispatcherPlatform';
          dispatcherPlatforms.push(dispatcherPlatform);
        });
        delete team.dispatcherPlatforms;
      }

      let updatedTeams = objectAssign([], state.teams);
      objectAssign(updatedTeams.find((team) => team.id === action.team.id), action.team);
      return objectAssign({}, state, {drivers: drivers, operators: operators, dispatchers: dispatchers, dispatcherPlatforms: dispatcherPlatforms,
      teams: updatedTeams });

    case types.TEAMS_FOR_SETTINGS_FETCHED:
      return objectAssign({}, state, {teams: action.teams});

    case types.ALL_PLATFORMS_FOR_FLEET_FETCHED:
      dispatcherPlatforms = [];
      _.map(action.dispatcherPlatforms, (platform) => {
          platform.role = 'dispatcherPlatform';
          dispatcherPlatforms.push(platform);
        });
      return objectAssign({}, state, { allDispatcherPlatforms: dispatcherPlatforms, loaded: true });

    case types.ALL_OPERATORS_FOR_FLEET_FETCHED:
      operators = [];
      _.map(action.operators, (operator) => {
          operator.role = 'operator';
          operators.push(operator);
        });
      return objectAssign({}, state, { allOperators: operators, loaded: true });

    case types.OPERATORS_FOR_OPERATORS_FETCHED:
      teams = action.teams;
      operators = [];

      _.map(teams, (team) => {
        if(team.operators) {
          _.map(team.operators, (operator) => {
            operator.role = 'operator';
            operators.push(operator);
          });
        }
      });
      return objectAssign({}, state, { operators: operators, loaded: true });

    case types.DISPATCHERS_FOR_OPERATORS_FETCHED:
      teams = action.teams;
      dispatchers = [];

      _.map(teams, (team) => {
        if(team.dispatchers) {
          _.map(team.dispatchers, (dispatcher) => {
            dispatcher.role = 'dispatcher';
            dispatchers.push(dispatcher);
          });
        }
      });
      return objectAssign({}, state, { dispatchers: dispatchers, loaded: true });

    case types.DRIVERS_FOR_OPERATORS_FETCHED:
      teams = action.teams;
      drivers = [];

      _.map(teams, (team) => {
        if(team.drivers) {
          _.map(team.drivers, (driver) => {
            driver.role = 'driver';
            drivers.push(driver);
          });
        }
      });
      return objectAssign({}, state, { drivers: drivers, loaded: true });

    case types.PLATFORMS_FOR_OPERATORS_FETCHED:
      teams = action.teams;
      dispatcherPlatforms = [];

      _.map(teams, (team) => {
        if(team.dispatcherPlatforms) {
          _.map(team.dispatcherPlatforms, (platform) => {
            platform.role = 'dispatcherPlatform';
            dispatcherPlatforms.push(platform);
          });
        }
      });
      return objectAssign({}, state, { dispatcherPlatforms: dispatcherPlatforms, loaded: true });

    case types.ALL_DISPATCHERS_FOR_FLEET_FETCHED:
      dispatchers = [];
      _.map(action.dispatchers, (dispatcher) => {
          dispatcher.role = 'dispatcher';
          dispatchers.push(dispatcher);
        });
      return objectAssign({}, state, { allDispatchers: dispatchers, loaded: true });

    case types.ALL_DRIVERS_FOR_FLEET_FETCHED:
      drivers = [];
      _.map(action.drivers, (driver) => {
          driver.role = 'driver';
          drivers.push(driver);
        });
      return objectAssign({}, state, { allDrivers: drivers, loaded: true });
    
    case types.COMPANY_WEBHOOK_FETCH_SUCCESS:
      return objectAssign({}, state, { webhooks: action.webHooks,
        loaded: true });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settingsPageReducer.js